import { render } from "./Front.vue?vue&type=template&id=590b06fb"
import script from "./Front.vue?vue&type=script&lang=js"
export * from "./Front.vue?vue&type=script&lang=js"
script.render = render

export default script